<template functional>
  <button
   class="btn flx_ctr"
   :disabled="props.text === ''"
   :aria-label="props.ariaLabel"
   v-on:click="props.func"
   >
    <slot />
   </button>
</template>

<script>
export default {
  name: 'SubmitBtn',
  props: ['text', 'ariaLabel', 'func']
}
</script>